var _circle, _rect, _circle2, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagPaksDestination(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#F1F1FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 93,
    height: 93,
    rx: 46.5,
    stroke: "#5754E5",
    strokeOpacity: 0.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 46,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15697_254581",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 92,
    height: 92
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 101C80.4051 101 101 80.4051 101 55C101 29.5949 80.4051 9 55 9C29.5949 9 9 29.5949 9 55C9 80.4051 29.5949 101 55 101Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15697_254581)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15697_254581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.764 9H-7.23633V101H130.764V9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.763 6.29492H27.9395V103.707H130.763V6.29492Z",
    fill: "#01411C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.127 76.6465C85.8295 76.6465 96.127 66.349 96.127 53.6465C96.127 40.9439 85.8295 30.6465 73.127 30.6465C60.4244 30.6465 50.127 40.9439 50.127 53.6465C50.127 66.349 60.4244 76.6465 73.127 76.6465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.096 64.0326C100.548 56.52 101.309 43.5786 93.7964 35.127C86.2838 26.6754 73.3424 25.9142 64.8908 33.4267C56.4392 40.9392 55.678 53.8807 63.1905 62.3322C70.703 70.7838 83.6445 71.5451 92.096 64.0326Z",
    fill: "#01411C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9245 37.0911L90.3331 47.6757L76.4999 44.6428L89.474 38.9655L82.3147 51.1845L80.9245 37.0911Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15697_254581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138,
    height: 92,
    fill: "white",
    transform: "translate(-7.23633 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPaksDestination);
export default __webpack_public_path__ + "static/media/flagPaksDestination.2b108860a3224cad7772453c69fef3ef.svg";
export { ForwardRef as ReactComponent };